import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { Products } from './types'

export const fetchProductList = async (params?: { abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url('/admin/1.0/products')
    .signal(params?.abortCtrl)
    .get()
    .json<ListingResponse<Products>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return err.message
    })
}
export const fetchProductByIds = async (productIds: string[], params?: { abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url(`/admin/1.0/products/${productIds.join(',')}`)
    .signal(params?.abortCtrl)
    .get()
    .json<ListingResponse<Products>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return err.message
    })
}
